/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const incorrectPenaltySectionStyle = {
  container: {
    textAlign: "center",
  },
  heading: {
    marginBottom: "50px",
  },
  gridContainer: {
    maxWidth: "800px",
    margin: "auto",
  },
  img: {
    maxWidth: "200px",
    width: "100%",
    height: "100%",
  },
  imageContainer: {
    padding: "10px",
    textAlign: { xs: "center", md: "right" },
  },
  text: {
    maxWidth: "520px",
    padding: "1rem",
    textAlign: { xs: "center", md: "left" },
  },
};

export default incorrectPenaltySectionStyle;
